export default __webpack_public_path__ + "static/cambridge-36213baab64359dce47649e55393c0e2.png";